module.exports = __webpack_public_path__ + "static/media/yellow-blue.fa68a295.png";